console.log('process.env.BUILD_ENV ---------------', process.env.BUILD_ENV)
console.log('/////////////////////////////////////////////////////////////')

let apiDomain = ''
switch (process.env.BUILD_ENV) {
  case 'dev':
    apiDomain = 'https://api.btokdev.com/h5'
    break;
  case 'test':
    apiDomain = 'https://bytest3.btcchat.io/h5'
    break;
  case 'pre':
    apiDomain = 'https://api.btokpre.com/h5'
    break;
  case 'prod':
    apiDomain = 'https://api1.sydrd.cn/h5'
    break;
  default:
    break;
}

module.exports = {
  apiDomain
}



// WEBPACK FOOTER //
// ./app.config.js